/**
 * Libraries module theme — aliases app brand (Patient indigo SoT).
 *
 * Prefer importing from here in Libraries UI so the module stays swappable
 * without reaching into Patients/. Color changes still flow from patientTheme.
 */
import { BRAND_THEME, BRAND_THEME_HEX } from "../../ui/brandTheme";

export const LIBRARIES_THEME = BRAND_THEME;
export const LIBRARIES_THEME_HEX = BRAND_THEME_HEX;

export const LIBRARIES_BTN = {
  primary: `inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-semibold rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.primary}`,
  outline: `inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-medium rounded-md border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.outline}`,
  soft: `inline-flex items-center justify-center gap-1 h-5 px-1.5 text-[10px] font-medium rounded border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.soft}`,
  danger:
    "inline-flex items-center justify-center gap-1 h-5 w-5 p-0 text-[10px] font-medium rounded border border-red-200 bg-red-50 text-red-700 hover:bg-red-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
  clear:
    "inline-flex items-center gap-1 h-8 px-2.5 text-xs font-medium text-indigo-700 hover:bg-indigo-50 rounded-md border border-indigo-200 transition-colors whitespace-nowrap",
  modalPrimary: `inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-semibold rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.primary}`,
  modalCancel:
    "inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-medium rounded-md border border-slate-300 bg-white text-slate-700 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed",
};

export const LIBRARIES_FIELD = {
  search: `w-full h-8 pl-9 pr-8 text-sm bg-white border border-indigo-200 rounded-md text-slate-800 placeholder:text-slate-400 outline-none transition-colors ${BRAND_THEME.fieldFocus}`,
  select: `appearance-none h-8 min-w-[120px] pl-3 pr-8 text-sm rounded-md border border-indigo-200 text-slate-700 bg-white outline-none cursor-pointer transition-colors ${BRAND_THEME.fieldFocus}`,
  selectActive: "border-indigo-400 text-indigo-700 font-medium bg-indigo-50/60",
};

export const LIBRARIES_MODAL = {
  backdrop:
    "fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40",
  panel:
    "w-full max-w-lg rounded-xl border border-indigo-200 bg-white shadow-xl flex flex-col overflow-hidden max-h-[90vh]",
  head: `flex items-center justify-between gap-3 px-4 py-3 border-b shrink-0 ${BRAND_THEME.modalHead}`,
  title: `text-sm font-semibold uppercase tracking-wide ${BRAND_THEME.modalTitle}`,
  body: "p-4 overflow-y-auto flex-1 space-y-3 bg-slate-50/40",
  footer:
    "flex items-center justify-end gap-2 px-4 py-3 border-t border-indigo-100 bg-indigo-50/40 shrink-0",
  close:
    "inline-flex h-7 w-7 items-center justify-center rounded-md text-slate-500 hover:bg-indigo-50 hover:text-indigo-700 transition-colors shrink-0",
};

/** Rail uses brand indigo (was blue). */
export const LIBRARIES_RAIL = {
  wrap: "border-indigo-200 bg-white",
  header: "bg-indigo-600 text-white",
  item: "text-indigo-800 hover:bg-indigo-50 border-indigo-100",
  itemActive: "bg-indigo-50 text-indigo-900 font-semibold border-indigo-200",
  itemIcon: "text-indigo-500",
  itemIconActive: "text-indigo-600",
};

export function librariesThemeCssVars() {
  const h = LIBRARIES_THEME_HEX;
  return {
    "--lib-brand": h.brand,
    "--lib-soft": h.soft,
    "--lib-border": h.border,
    "--lib-strong": h.strong,
    "--lib-text": h.text,
    "--lib-title": h.title,
  };
}

export const LIBRARY_STATUS_PILL = {
  Active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Inactive: "bg-slate-50 text-slate-600 border-slate-200",
};
